import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';

const CompanyCulture = ({ gallery, testimonials }) => {
  const [selectedImage, setSelectedImage] = useState(null);

  return (
    <div className="bg-card rounded-lg border border-border p-6 lg:p-8">
      <h2 className="text-2xl font-bold text-foreground mb-6">Company Culture & Life</h2>
      <div className="space-y-8">
        <div>
          <h3 className="text-lg font-semibold text-foreground mb-4">Workplace Gallery</h3>
          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4">
            {gallery?.map((item) => (
              <div
                key={item?.id}
                className="relative aspect-square rounded-lg overflow-hidden cursor-pointer group"
                onClick={() => setSelectedImage(item)}
              >
                <Image
                  src={item?.image}
                  alt={item?.imageAlt}
                  className="w-full h-full object-cover transition-smooth group-hover:scale-110"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-background/80 to-transparent opacity-0 group-hover:opacity-100 transition-smooth flex items-end p-4">
                  <p className="text-sm text-white font-medium">{item?.caption}</p>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="pt-8 border-t border-border">
          <h3 className="text-lg font-semibold text-foreground mb-4">Employee Testimonials</h3>
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
            {testimonials?.map((testimonial) => (
              <div key={testimonial?.id} className="p-6 bg-muted/50 border border-border rounded-lg">
                <div className="flex items-start gap-4 mb-4">
                  <div className="w-12 h-12 rounded-full overflow-hidden flex-shrink-0">
                    <Image
                      src={testimonial?.avatar}
                      alt={testimonial?.avatarAlt}
                      className="w-full h-full object-cover"
                    />
                  </div>
                  <div className="flex-1">
                    <h4 className="font-semibold text-foreground">{testimonial?.name}</h4>
                    <p className="text-sm text-muted-foreground">{testimonial?.role}</p>
                    <p className="text-xs text-muted-foreground mt-1">{testimonial?.tenure}</p>
                  </div>
                </div>
                <p className="text-muted-foreground italic leading-relaxed">
                  "{testimonial?.quote}"
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
      {selectedImage && (
        <>
          <div
            className="fixed inset-0 bg-background/95 backdrop-blur-sm z-[2000]"
            onClick={() => setSelectedImage(null)}
          />
          <div className="fixed inset-0 z-[2001] flex items-center justify-center p-4">
            <div className="relative max-w-4xl w-full bg-card rounded-lg overflow-hidden">
              <button
                onClick={() => setSelectedImage(null)}
                className="absolute top-4 right-4 w-10 h-10 bg-background/80 backdrop-blur-sm rounded-full flex items-center justify-center hover:bg-background transition-smooth z-10"
              >
                <Icon name="X" size={20} />
              </button>
              <Image
                src={selectedImage?.image}
                alt={selectedImage?.imageAlt}
                className="w-full h-auto"
              />
              <div className="p-6 bg-muted">
                <p className="text-foreground font-medium">{selectedImage?.caption}</p>
              </div>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default CompanyCulture;